import { Component } from '@angular/core';

@Component({
  selector: 'water-holding-reference',
  template: `
    <table class="table table-striped card-info">
      <thead>
      <tr>
        <th>Soil Type</th>
        <th>Water Holding Capacity</th>
        <th>Recommended days per week to irrigate (indicative)</th>
      </tr>
      </thead>
      <tbody>
        <tr>
          <td>Sand</td>
          <td class="text-right">27,154 gal/acre</td>
          <td class="text-center">7</td>
        </tr>
        <tr>
          <td>Sandy loam</td>
          <td class="text-right">54,308 gal/acre</td>
          <td class="text-center">5</td>
        </tr>
        <tr>
          <td>Loam</td>
          <td class="text-right">81,462 gal/acre</td>
          <td class="text-center">3</td>
        </tr>
        <tr>
          <td>Clay loam</td>
          <td class="text-right">103,185 gal/acre</td>
          <td class="text-center">2</td>
        </tr>
        <tr>
          <td>Clay</td>
          <td class="text-right">108,616 gal/acre</td>
          <td class="text-center">2</td>
        </tr>
      </tbody>
    </table>
  `
})
export class WaterHoldingReference {}






// WEBPACK FOOTER //
// ./src/pages/water-holding-reference/water-holding-reference.ts